module.exports = __webpack_public_path__ + "img/clock-white.5c9e0339.svg";